/**
 * Google Maps configuration.
 * Client-side Maps keys are expected in the browser bundle; restrict by
 * HTTP referrer + enabled APIs in Google Cloud Console.
 *
 * Required APIs for this site (project must enable all three):
 * - Places API (New)  → address autocomplete on forms
 * - Maps JavaScript API → optional interactive maps
 * - Maps Embed API → optional Embed iframes (neighbourhood maps use keyless embed fallback)
 *
 * REACT_APP_GOOGLE_MAPS_API_KEY overrides the default when set at build time.
 * The default below is the active site key and must override any previous key.
 */
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyDZOFf-aneX8P45mp9wLhfWZ_DT7Ur9BnM";

export const isGoogleMapsConfigured = Boolean(
  GOOGLE_MAPS_API_KEY &&
    GOOGLE_MAPS_API_KEY !== "YOUR_GOOGLE_MAPS_API_KEY" &&
    GOOGLE_MAPS_API_KEY !== "your-google-maps-api-key"
);

/** Geneva region default center */
export const GENEVA_CENTER = { lat: 46.2044, lng: 6.1432 };

/** Places API (New) endpoints */
export const PLACES_AUTOCOMPLETE_URL =
  "https://places.googleapis.com/v1/places:autocomplete";

export const placesDetailsUrl = (placeId) =>
  `https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}`;
